"use strict";
module.exports = (policy) => {
    const result = {};
    policy.split(";").forEach((directive) => {
        const [directiveKey, ...directiveValue] = directive.trim().split(/\s+/g);
        if (directiveKey &&
            !Object.prototype.hasOwnProperty.call(result, directiveKey)) {
            if (directiveKey === "__proto__") {
                Object.defineProperty(result, directiveKey, {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: directiveValue,
                });
            }
            else {
                result[directiveKey] = directiveValue;
            }
        }
    });
    return result;
};
